import Component from "@glimmer/component"
import OutlineDateRowIsland from "react-app/islands/OutlineDateRowIsland"

interface Signature {
  Args: {
    courseId: string
    planbookId: string
    rotationCalendarId: string
    dateString: string
    /** How deep this date sits inside units — drives the row's indent class. */
    unitDepth: number
    hasFocus: boolean
    canBeEditable: boolean
    isSelectable: boolean
    selectedDateStrings: Array<string>
    onLessonSelect?: (cardStackId: string | null, dateString: string) => void
    onFocusIn?: () => void
    arrowUpDown: (direction: "up" | "down") => void
  }
}

export default class OutlineDateRowIslandBridge extends Component<Signature> {
  readonly OutlineDateRowIsland = OutlineDateRowIsland
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Bridges::OutlineDateRowIslandBridge": typeof OutlineDateRowIslandBridge
  }
}
